import React from 'react';
import PropTypes from 'prop-types';

function EmailLink({ label, mailto }) {
  return (
    <div>
      {label && <span>{label}: </span>}
      <a href={`mailto:${mailto}`}>{mailto}</a>
    </div>
  );
}

EmailLink.propTypes = {
  mailto: PropTypes.string.isRequired,

  label: PropTypes.string,
};

export default EmailLink;



// WEBPACK FOOTER //
// ./src/modules/common/EmailLink.js